import { useEffect, useRef } from 'react';

interface Props {
  children: React.ReactNode;
  isActive: boolean;
  onSetActive: () => void;
  className?: string;
}

export const ModalWindow: React.FC<Props> = ({
  children,
  isActive,
  onSetActive,
  className = '',
}) => {
  const modalRef = useRef<HTMLDivElement>(null);

  // Закрытие по ESC
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onSetActive();
      }
    };

    if (isActive) {
      document.addEventListener('keydown', handleEscape);
      // Блокируем скролл страницы
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.removeEventListener('keydown', handleEscape);
      document.body.style.overflow = 'unset';
    };
  }, [isActive, onSetActive]);

  // Закрытие по клику вне модалки
  const handleBackdropClick = (event: React.MouseEvent<HTMLDivElement>) => {
    if (event.target === event.currentTarget) {
      console.log(event.target, event.currentTarget);
      onSetActive();
    }
  };

  // Если модалка не активна - не рендерим
  if (!isActive) return null;

  return (
    <>
      {/* Модальное окно */}
      <div
        ref={modalRef}
        className={`
          fixed inset-0 z-50 flex items-center justify-center p-4
          transition-all duration-300 ease-in-out
          ${isActive ? 'opacity-100' : 'opacity-0 pointer-events-none'}
          `}
        role="dialog"
        aria-modal="true"
        aria-labelledby="modal-title"
      >
        {/* Затемнение фона */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300"
          onClick={handleBackdropClick}
          aria-hidden="true"
        />
        <div
          className={`
            bg-white rounded-2xl shadow-xl max-h-[90vh] overflow-y-auto p-4 sm:px-8 sm:py-5
            max-w-2xl mx-auto
            transition-transform duration-300 z-[60]
            ${isActive ? 'scale-100' : 'scale-95'}
            ${className}
          `}
          onClick={(e) => e.stopPropagation()} // Предотвращаем закрытие при клике внутри
        >
          {children}
        </div>
      </div>
    </>
  );
};
